import { useState } from 'react';
import { Button, FileDropField, Label } from '@/shared/ui';
import type { PortfolioUploadPhoto } from '../model';

export const PortfolioLogoField = ({
  photo,
  existingUrl,
  disabled,
  onUpload,
  onRemove,
  onRetry,
  onRefresh,
}: {
  photo?: PortfolioUploadPhoto;
  existingUrl?: string | null;
  disabled?: boolean;
  onUpload: (file: File) => void;
  onRemove: () => void;
  onRetry: () => void;
  onRefresh: () => void;
}) => {
  const [failedUrl, setFailedUrl] = useState<string | null>(null);
  const url = photo?.previewUrl ?? existingUrl;
  return (
    <section className="space-y-2">
      <Label htmlFor="portfolio-logo">브랜드 로고</Label>
      <FileDropField
        id="portfolio-logo"
        accept="image/jpeg,image/png,image/webp"
        disabled={disabled}
        buttonLabel="로고 선택"
        onFiles={([file]) => {
          if (file) {
            setFailedUrl(null);
            onUpload(file);
          }
        }}
      />
      {url ? (
        <div className="flex flex-wrap items-center gap-3">
          {failedUrl === url ? (
            <div>
              <p>로고를 불러오지 못했습니다.</p>
              <Button
                type="button"
                size="sm"
                variant="outline"
                disabled={disabled}
                onClick={() => {
                  setFailedUrl(null);
                  onRefresh();
                }}
              >
                로고 다시 불러오기
              </Button>
            </div>
          ) : (
            <img
              src={url}
              alt="브랜드 로고 미리보기"
              className="size-20 object-contain"
              onError={() => setFailedUrl(url)}
            />
          )}
          <Button type="button" size="sm" variant="outline" disabled={disabled} onClick={onRemove}>
            로고 제거
          </Button>
        </div>
      ) : null}
      {photo?.status === 'PENDING' ? <p>로고 처리 중…</p> : null}
      {photo?.error ? (
        <p role="alert" className="text-sm text-destructive">
          {photo.error}
        </p>
      ) : null}
      {photo?.status === 'FAILED' ? (
        <Button type="button" size="sm" disabled={disabled} onClick={onRetry}>
          로고 재시도
        </Button>
      ) : null}
    </section>
  );
};
